import Action from 'redux/helpers/createAction'
const name = 'reports'

export const loadDomains = Action(name + '/LOAD_DOMAINS')

export const loadDomainsSuccess = Action(name + '/LOAD_DOMAINS_SUCCESS', domains => ({
  domains
}))

export const loadDomainsFailure = Action(name + '/LOAD_DOMAINS_FAILURE', error => ({
  error
}))

export const sortDomainsReports = Action(name + '/SORT_DOMAINS', (value, order) => ({
  value,
  order
}))

export const loadReports = Action(name + '/GET_REPORTS', domainId => ({
  domainId
}))

export const loadReportsSuccess = Action(name + '/GET_REPORTS_SUCCESS', (domainId, reports) => ({
  domainId,
  reports
}))

export const loadReportsFailure = Action(name + '/GET_REPORTS_FAILURE', error => ({
  error
}))

export const loadPreviousReports = Action(name + '/GET_PREVIOUS_REPORTS', (domainId, reportId) => ({
  domainId,
  reportId
}))

export const loadPreviousReportsSuccess = Action(
  name + '/GET_PREVIOUS_REPORTS_SUCCESS',
  (domainId, reportId, previousReports) => ({
    domainId,
    reportId,
    previousReports
  })
)

export const loadPreviousReportsFailure = Action(name + '/GET_PREVIOUS_REPORTS_FAILURE', error => ({
  error
}))

export const createReport = Action(name + '/CREATE_REPORT', (domainId, payload) => ({
  domainId,
  payload
}))

export const createReportSuccess = Action(name + '/CREATE_REPORT_SUCCESS', (domainId, report) => ({
  domainId,
  report
}))

export const createReportFailure = Action(name + '/CREATE_REPORT_FAILURE', error => ({
  error
}))

export const updateReport = Action(name + '/UPDATE_REPORT', (domainId, reportId, payload) => ({
  domainId,
  reportId,
  payload
}))

export const updateReportSuccess = Action(
  name + '/UPDATE_REPORT_SUCCESS',
  (domainId, reportId, report) => ({
    domainId,
    reportId,
    report
  })
)

export const updateReportFailure = Action(name + '/UPDATE_REPORT_FAILURE', error => ({
  error
}))

export const deleteReport = Action(name + '/DELETE_REPORT', (domainId, id) => ({
  domainId,
  id
}))

export const deleteReportSuccess = Action(name + '/DELETE_REPORT_SUCCESS', (domainId, id) => ({
  domainId,
  id
}))

export const deleteReportFailure = Action(name + '/DELETE_REPORT_FAILURE', error => ({
  error
}))

export const deleteReportLogo = Action(name + '/DELETE_REPORT_LOGO', (domainId, id) => ({
  domainId,
  id
}))

export const deleteReportLogoSuccess = Action(
  name + '/DELETE_REPORT_LOGO_SUCCESS',
  (domainId, id) => ({
    domainId,
    id
  })
)

export const deleteReportLogoFailure = Action(name + '/DELETE_REPORT_LOGO_FAILURE', error => ({
  error
}))

export const viewPrevious = Action(name + '/VIEW_PREVIOUS_REPORT', (domainId, reportId) => ({
  domainId,
  reportId
}))

export const downloadPrevious = Action(
  name + '/VIEW_DOWNLOAD_REPORT',
  (domainId, reportId, dateFrom, dateTo) => ({
    domainId,
    reportId,
    dateFrom,
    dateTo
  })
)
